<template>
  <div>
    <div id="cy">
    </div>
  </div>
</template>
<script>
// import NoticeItem from '@/components/Notice/NoticeItem'
// import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import OrganizationItem from '@/components/People/OrganizationItem'
import ManageWrapperComponent from '@/components/Manage/ManageWrapperComponent'
import drag from '@branu-jp/v-drag'
import VueDragscroll from 'vue-dragscroll'
import NetWorkContent from '@/components/Okr/NetWorkContent'
import moment from 'moment'
import {progress} from '@/main'
import tippy, {delegate} from 'tippy.js'
import dagre from 'cytoscape-dagre'
import 'tippy.js/dist/tippy.css'
Vue.use(VueDragscroll)
var cytoscape = require('cytoscape')
var popper = require('cytoscape-popper')
delegate('#root', {
  target: '[data-tippy-content]'
})
cytoscape.use(popper)
cytoscape.use(dagre)
export default {
  name: 'NetWork',
  mixedins: [validationMixin],
  components: {
    // NoticeItem
    OrganizationItem,
    ManageWrapperComponent,
    NetWorkContent
  },
  directives: {
    drag
  },
  props: {
    date: {
      to: null,
      from: null
    },
    searchType: String
  },
  watch: {
    date () {
      this.generateCytoscapeData()
      this.tippes = {}
    },
    okrContents () {
      console.log('data', this.okrContents)
    },
    getUsers () {
      console.log('getusers', this.getUsers)
      if (Object.keys(this.getUsers).length > 0 && !this.load) {
        this.generateCytoscapeData()
      }
    },
    getObjectives () {
      if (Object.keys(this.getObjectives).length > 0 && !this.load) {
        this.generateCytoscapeData()
      }
    },
    getKeyresults () {
      if (Object.keys(this.getKeyresults).length > 0 && !this.load) {
        this.generateCytoscapeData()
      }
    }
  },
  data: function () {
    return {
      tag: 'ManageGroupEdit',
      open: false,
      x1: 100,
      y1: 100,
      contentLength: {
        // マジックナンバー化しそうだったので早めに置いとく。これを動的に〜はまだ決めてない
        width: 150,
        height: 100
      },
      prev_pos: {
        x: 0,
        y: 0
      },
      styles: {},
      circleIds: ['takeru', 'yamamoto'],
      edgeFornode: {
      },
      sample_edge: [
        {
          x1: 200,
          y1: 100,
          x2: 400,
          y2: 300,
          stroke: 'rgb(255,0,0)',
          width: 50
        }
      ],
      sample_edges: {
        tanaka_aoki: {
          x1: 242,
          y1: 52,
          x2: 0,
          y2: 0
        }
      },
      targetId: '',

      deleteUsers: {},
      groupUsers: {},
      groups: {},
      searchText: '',
      groupName: '',
      oldMembers: [],
      groupOwnerId: '',
      ownerEdit: false,
      id: this.$route.params.id,
      isRegistering: false,
      showModal: false,
      checkOrganization: '',
      // parentOrganization
      checkedOrganization: '',
      childGroups: {},
      depth: 1,
      okrContents: {},
      checkedDepth: 0,
      doneStarter: false,
      userNexts: {},
      left: 0,
      top: 0,
      load: false, // グラフが読み込まれたらtrue
      cytoscapeDatas: {
        nodes: [],
        edges: [],
        infos: {}
      },
      targets: {
        // edge間でzeroになる現象の調査用
      },
      tippes: {}
    }
  },
  validations: {
    groupName: {
      required
    }
  },
  computed: {
    ...mapGetters([
      'getUserId'
    ]),
    ...mapGetters('objectives/', [
      'getCurrentObjectives',
      'getObjectiveById',
      'getObjectives',
      'getObjectivesByUserId',
      'getObjectives'
    ]),
    ...mapGetters('keyResults/', [
      'getCurrentKeyresults',
      'getKeyresultById',
      'getKeyresultsByUserId',
      'getKeyresults'
    ]),
    ...mapGetters('users/', [
      'getUsers',
      'getUserInfoById'
    ]),
    getUserIds () {
      return Object.keys(this.getUsers)
    },
    edges () {
      // TIPS: 線がある一定のnetworkの広さ？を越えると、
      // 描画されなくなるがその問題を解決するには、SVGの領域を広げる or left,topの移動幅を制限する
      if (!this.doneStarter) {
        // mountedだったらなんか上手く行かない？（のでcreatedも上手く行かないでしょう想定）
        this.okrNetWorkStarter()
      }
      let nodes = this.okrContents
      let edgeList = {} // edgeKeyで参照する連想配列
      for (let node of Object.keys(this.okrContents)) {
        if (nodes[node].hasOwnProperty('next')) {
          for (let targetNode of nodes[node]['next']) {
            if (!nodes.hasOwnProperty(targetNode)) {
              continue
            }
            const edgeKey = node + '_' + targetNode // ユニークなkey + ユニークなkeyならユニークなkeyができるため暫定的に
            if (!this.edgeFornode.hasOwnProperty(node)) {
              this.edgeFornode[node] = []
            }
            if (!this.edgeFornode.hasOwnProperty(targetNode)) {
              this.edgeFornode[targetNode] = []
            }
            this.edgeFornode[node].push(edgeKey)
            this.edgeFornode[targetNode].push(edgeKey)
            if (!edgeList.hasOwnProperty(edgeKey)) {
              edgeList[edgeKey] = {}
            }
            edgeList[edgeKey] = {
              x1: nodes[node]['style']['left'] + this.contentLength['width'] / 2 || this.contentLength['width'] / 2,
              y1: nodes[node]['style']['top'] + this.contentLength['height'] / 2 || this.contentLength['height'] / 2,
              x2: nodes[targetNode]['style']['left'] + this.contentLength['width'] / 2 || this.contentLength['width'] / 2,
              y2: nodes[targetNode]['style']['top'] + this.contentLength['height'] / 2 || this.contentLength['height'] / 2,
              color: 'green'
            }
            // ベクトル（正規化）を出し、それをcontentのながさで出すことでそこまでのベクトルの長さを求めることができる
            const xLength = edgeList[edgeKey].x1 - edgeList[edgeKey].x2
            const yLength = edgeList[edgeKey].y1 - edgeList[edgeKey].y2
            const norm = Math.sqrt(xLength ** 2 + yLength ** 2)
            // 4のマジックナンバーはものすごく気になるが、表示上ズレるので、(計算が間違ってるというよりもsvgだとかdomのズレのようなモノだと思ってる)
            const xLengthVevtor = (this.contentLength['width'] / 2) - 16
            const yLengthVevtor = this.contentLength['height'] / 2
            const contentVectorLength = Math.sqrt((xLengthVevtor * xLength / norm) ** 2 + (yLengthVevtor * yLength / norm) ** 2)
            edgeList[edgeKey].vectorlength = contentVectorLength - 24// 矢印分
          }
        }
        if (nodes[node].hasOwnProperty('keyResults')) {
          // nextを改修するよりも、keyResults用に無向グラフを作成する方が帰ってバグ発生時に直しやすいかと
          for (let targetNode of nodes[node]['keyResults']) {
            const edgeKey = node + '_' + targetNode // ユニークなkey + ユニークなkeyならユニークなkeyができるため暫定的に
            if (!this.edgeFornode.hasOwnProperty(node)) {
              this.edgeFornode[node] = []
            }
            if (!this.edgeFornode.hasOwnProperty(targetNode)) {
              this.edgeFornode[targetNode] = []
            }
            this.edgeFornode[node].push(edgeKey)
            this.edgeFornode[targetNode].push(edgeKey)
            if (!edgeList.hasOwnProperty(edgeKey)) {
              edgeList[edgeKey] = {}
            }
            edgeList[edgeKey] = {
              x1: nodes[node]['style']['left'] + this.contentLength['width'] / 2 || this.contentLength['width'] / 2,
              y1: nodes[node]['style']['top'] + this.contentLength['height'] / 2 || this.contentLength['height'] / 2,
              x2: nodes[targetNode]['style']['left'] + this.contentLength['width'] / 2 || this.contentLength['width'] / 2,
              y2: nodes[targetNode]['style']['top'] + this.contentLength['height'] / 2 || this.contentLength['height'] / 2,
              color: 'blue',
              noneMarker: true
            }
            // ベクトル（正規化）を出し、それをcontentのながさで出すことでそこまでのベクトルの長さを求めることができる
            const xLength = edgeList[edgeKey].x1 - edgeList[edgeKey].x2
            const yLength = edgeList[edgeKey].y1 - edgeList[edgeKey].y2
            const norm = Math.sqrt(xLength ** 2 + yLength ** 2)
            // 表示上ズレる場合計算が間違ってるというよりもsvgだとかdomのズレのようなモノだと思ってる
            const xLengthVevtor = this.contentLength['width'] / 2
            const yLengthVevtor = this.contentLength['height'] / 2
            const contentVectorLength = Math.sqrt((xLengthVevtor * xLength / norm) ** 2 + (yLengthVevtor * yLength / norm) ** 2)
            edgeList[edgeKey].vectorlength = contentVectorLength // 矢印分
          }
        }
      }
      return edgeList
    },
    hierarchyGrant () {
      const userKeys = Object.keys(this.getUsers).reverse()
      // user-o-krs単位でInteger型で順位を決める (順位ごとに上から下に下す)
      // 利用ユーザーが選択した階層表示でないので、ある程度大雑把に決めれる（？）
      // 選定基準はnext先するものがあるかどうか
      // ここ一度実行だけにしたい
      let users = {}
      let userNexts = {} // これどうなるか分からんがここでnext取れるならStarterに渡せるよね
      let checkrelations = {}
      for (let user of userKeys) {
        if (user === '.key') {
          continue
        }
        if (!users.hasOwnProperty(user)) {
          users[user] = 0
        }
        for (let okrKey of Object.keys(this.getObjectivesByUserId(user))) {
          const okr = this.getObjectivesByUserId(user)[okrKey]
          if (!okr) {
            continue
          }
          if (okr.hasOwnProperty('relations')) {
            for (let relationKey of Object.keys(okr['relations'])) {
              checkrelations[relationKey] = okr['relations'][relationKey]
              if (!userNexts.hasOwnProperty(user)) {
                userNexts[user] = {}
              }
              const relation = okr['relations'][relationKey]
              if (relation['dir'] === 'src') {
                // prev向きは無視する
                continue
              }
              if (!userNexts[user].hasOwnProperty(okrKey)) {
                userNexts[user][okrKey] = {}
              }
              if (!userNexts[user][okrKey].hasOwnProperty('next')) {
                userNexts[user][okrKey]['next'] = {}
              }
              userNexts[user][okrKey]['next'][relation['key']] = relation['type']
              // 自分でないものをnextでさしてるならばこれは順位変更ありえるよね？
              const targetId = relation['userId']
              if (!users.hasOwnProperty(targetId)) {
                users[targetId] = 0
              }
              // 見た目上下に行って欲しいためのifないと振動しちゃって高低差生まれにくい
              if (users[user] <= users[targetId]) {
                users[user] = users[targetId] + 1 // 数字が増えるほど下層に近くなる
              }
            }
          }
        }
      }
      // users[this.getUserId] = 0
      // users['tXuri3KxSKWARei2ExqPcGrv0r63'] = 1 // okr-network-2
      // users['P7eY8GVLS9brZ84cwIRUQiOolI23'] = 1
      console.log('users', users)
      this.userNexts = userNexts
      return userNexts
    }
  },
  mounted: function () {
    this.generateCytoscapeData()
    // console.log('userNexts', this.hierarchyGrant, this.userNexts)
    this.getConsole()
  },
  methods: {
    userImage: function (userIds) {
      if (userIds.length > 1) {
        return 'static/img/assets/nav_people_off.png'
      }
      let userId = userIds[0]
      if (this.getUserInfoById(userId) && this.getUserInfoById(userId).hasOwnProperty('userIcon')) {
        return this.getUserInfoById(userId).userIcon
      } else {
        return 'static/img/noImage.png'
      }
    },
    userName: function (userIds) {
      return userIds.map(x => this.getUserInfoById(x) && this.getUserInfoById(x).hasOwnProperty('userName') ? this.getUserInfoById(x).userName : '')
    },
    takeStyle: function (obj) {
      this.okrContents[obj['id']]['style'] = obj['style']
    },
    getConsole: function () {
      console.log('values', this.generateCytoscapeData, this.okrContents)
    },
    isBetweenDate (item) {
      if (!item || !Object.keys(item).length) { return false }
      let dueDate = moment(item.dueDate || 0).format('YYYYMMDD')
      let startDate = item.startDate ? moment(item.startDate || 0).format('YYYYMMDD') : moment(item.dueDate || 0).format('YYYYMMDD')
      let fromDate = moment(this.date.from).format('YYYYMMDD')
      let toDate = moment(this.date.to).format('YYYYMMDD')
      switch (this.searchType) {
        case 'dueDate':
          return (this.date.from ? dueDate >= fromDate : true) && (this.date.to ? dueDate <= toDate : true)
        case 'startDate':
          return (this.date.from ? startDate >= fromDate : true) && (this.date.to ? startDate <= toDate : true)
        case 'active':
        default:
          return (this.date.from ? dueDate >= fromDate : true) && (this.date.to ? startDate <= toDate : true)
      }
    },
    getObj: function (userId) {
      let okrs = {}
      let i = 0
      for (let okr of Object.keys(this.getCurrentObjectives)) {
        if (i > 10) {
          break
        } else {
          i += 1
        }
        okrs[okr] = this.getCurrentObjectives[okr]
      }
      return okrs
    },
    setStyle: function (style) {
      return style || 0
    },
    okrNetWorkStarter: function (x, y) {
      // とりあえず,currentで作成し、いずれdata型からfunction型に変更userIdを引数としてcontentsをreturnする
      // let contents = {}
      let left = -50 // 最初に強調がきてしまうので
      let top = 0
      let hierarchyLeft = {}
      let increasedHierarchy = {}
      let registerKey = {} // ex:{itemId: 1}
      const users = this.hierarchyGrant
      // let targetHierarchy = 0 // targetが変更されたらleft,topを初期化しhirarchyに合わせる
      // let uniqueHierarchy = 0 // 横幅制限でtopが下がった場合ここを干渉
      // 200単位でleftとtopは変更？
      const userIds = Object.keys(users)
      // targetHierarchy = users[userIds[0]]
      let promises = []
      if (userIds.length === 0) {
        return false
      }
      for (let targetUserId of userIds) {
        const objs = this.getObjectivesByUserId(targetUserId, true)
        let activeObjKeys = Object.keys(objs).filter(objKey => this.isBetweenDate(objs[objKey]))
        let targetHierarchy = users[targetUserId]
        // 注釈がないと勘違いしてしまいそうになるのでコメント追加:objのみを対象とし、objが非アクティブならばkeyresultを表示しない(krはactive条件に関係ない)
        if (activeObjKeys.length > 0) {
          // objが存在するなら処理
          if (!hierarchyLeft.hasOwnProperty(targetHierarchy) || !increasedHierarchy.hasOwnProperty(targetHierarchy)) {
            hierarchyLeft[targetHierarchy] = 0
            increasedHierarchy[targetHierarchy] = 0
          }
          targetHierarchy = increasedHierarchy[targetHierarchy] + targetHierarchy
          left = hierarchyLeft[targetHierarchy]
          top = targetHierarchy * 400
          // ユーザーごとというのを強調したいため...
          hierarchyLeft[targetHierarchy] += 50
        }
        for (let objKey of activeObjKeys) {
          // 方針: keyresultの数がわかれば、並列的に処理できるのでそれで行うように変更する
          if (!objKey || !targetUserId) {
            continue
          }
          const obj = objs[objKey]
          if (objKey === '.key' || !obj || !objKey) {
            continue
          }
          if (!obj) {
            continue
          }
          if (registerKey.hasOwnProperty(objKey)) {
            continue
          } else {
            registerKey[objKey] = 1
          }
          promises.push(this.generateOkrTree(left, top, obj, objKey, targetUserId))
          if (objs[objKey].hasOwnProperty('keyresults')) {
            left += Object.keys(objs[objKey]['keyresults']).length * 200
          } else {
            left += 200
          }
          if (left > 6000) {
            increasedHierarchy[targetHierarchy] += 1
            targetHierarchy += 1
            if (!hierarchyLeft.hasOwnProperty(targetHierarchy)) {
              hierarchyLeft[targetHierarchy] = 0
            }
            left = hierarchyLeft[targetHierarchy]
            top += 400
            // uniqueHierarchy += 1
          }
          hierarchyLeft[targetHierarchy] = left
        }
        // if (objFlag) {
        //   left = 0
        //   top += 200
        // }
      }

      // const assign = Object.assign(this.okrContents, contents)
      // this.okrContents = contents
      // if (Object.keys(contents).length > 0) {
      //   this.doneStarter = true
      // }
      return Promise.all(promises).then((values) => {
        let contents = {}
        for (let value of values) {
          contents = Object.assign(contents, value)
        }
        if (values.length > 0) {
          this.okrContents = contents
          this.doneStarter = true
        }
      })
    },
    async generateOkrTree (left, top, obj, objKey, targetUserId) {
      // 大規模データでは著しく初期実行速度が低いため、できる限り並列処理できるようにする
      let contents = {}
      const keyHeight = 200
      // const firstPositionX = left
      if (!contents.hasOwnProperty(objKey)) {
        contents[objKey] = {}
        contents[objKey]['style'] = {}
        contents[objKey]['attribute'] = 'objective'
        contents[objKey]['userId'] = [targetUserId]
      }
      if (obj.hasOwnProperty('sharedOwners')) {
        contents[objKey]['userId'] = Object.keys(obj['sharedOwners'])
      }
      if (obj.hasOwnProperty('relations')) {
        if (this.userNexts[targetUserId].hasOwnProperty(objKey)) {
          contents[objKey]['next'] = Object.keys(this.userNexts[targetUserId][objKey]['next'])
        } else {
          for (let relationKey of Object.keys(obj['relations'])) {
            let relation = obj['relations'][relationKey]
            if (relation['dir'] === 'src') {
              // prev向きは無視する...すごく勿体無い計算量な気がしていやだが...
              continue
            }
            if (!contents[objKey].hasOwnProperty('next')) {
              contents[objKey]['next'] = []
            }
            contents[objKey]['next'].push(relation['key'])
          }
        }
      }
      let keyresultKeys = []
      if (obj.hasOwnProperty('keyresults')) {
        keyresultKeys = Object.keys(obj.keyresults)
      }
      contents[objKey]['data'] = obj
      if (keyresultKeys.length > 0) {
        contents[objKey]['keyResults'] = keyresultKeys
        contents[objKey]['style']['left'] = ((keyresultKeys.length * 200) - 200) / 2 + left
        contents[objKey]['style']['top'] = top
        let keyresultLeft = left
        for (let key of Object.keys(obj['keyresults'])) {
          // keyResultstyle
          if (key === '.key') {
            continue
          }
          if (!contents.hasOwnProperty(key)) {
            contents[key] = {}
            contents[key]['style'] = {}
            contents[key]['attribute'] = 'keyResult'
            contents[key]['userId'] = [targetUserId]
          }
          const keyResult = this.getKeyresultById(key, targetUserId)
          if (keyResult.hasOwnProperty('sharedOwners')) {
            contents[key]['userId'] = Object.keys(keyResult['sharedOwners'])
          }
          contents[key]['okr'] = objKey
          contents[key]['style']['left'] = keyresultLeft
          keyresultLeft += 200
          contents[key]['style']['top'] = top + keyHeight
          contents[key]['data'] = keyResult
        }
      } else {
        contents[objKey]['style'] = {left: left, top: top}
      }
      return contents
    },
    async generateOkrData (obj, objKey, targetUserId) {
      // 大規模データでは著しく初期実行速度が低いため、できる限り並列処理できるようにする
      let contents = {}
      // const firstPositionX = left
      if (!contents.hasOwnProperty(objKey)) {
        contents[objKey] = {}
        contents[objKey]['id'] = objKey
        contents[objKey]['userId'] = [targetUserId]
      }
      if (obj.hasOwnProperty('sharedOwners')) {
        contents[objKey]['userId'] = Object.keys(obj['sharedOwners'])
      }
      if (obj.hasOwnProperty('progress')) {
        contents[objKey]['progress'] = Number(obj.progress)
      } else {
        contents[objKey]['progress'] = 0
      }
      if (obj.hasOwnProperty('relations')) {
        for (let relationKey of Object.keys(obj['relations'])) {
          let relation = obj['relations'][relationKey]
          let relationUser = relation.userId
          let key = relation['key']
          let objs = this.getObjectivesByUserId(relationUser, true, true)
          let keys = this.getKeyresultsByUserId(relationUser, true, true)
          if (!objs.hasOwnProperty(key) && keys.hasOwnProperty(key)) {
            key = keys[key].parentObjId
          }
          if (relation['dir'] === 'dst') {
            if (!contents[objKey].hasOwnProperty('next')) {
              contents[objKey]['next'] = []
            }
            contents[objKey]['next'].push(key)
            this.targets[key] = {type: 'objectives', id: key, userId: relationUser}
          } else {
            if (!contents[objKey].hasOwnProperty('prev')) {
              contents[objKey]['prev'] = []
            }
            contents[objKey]['prev'].push(key)
          }
        }
      }
      const keyresultKeys = Object.keys(obj.keyresults || {})
      contents[objKey]['data'] = obj
      if (keyresultKeys.length > 0) {
        for (let key of Object.keys(obj['keyresults'])) {
          // keyResultstyle
          if (key === '.key') {
            continue
          }
          const keyResult = this.getKeyresultById(key, targetUserId)
          if (keyResult.hasOwnProperty('relations')) {
            for (let relationKey of Object.keys(keyResult['relations'])) {
              let relation = keyResult['relations'][relationKey]
              let relationUser = relation.userId
              let key = relation['key']
              let objs = this.getObjectivesByUserId(relationUser, true, true)
              let keys = this.getKeyresultsByUserId(relationUser, true, true)
              if (!objs.hasOwnProperty(key) && keys.hasOwnProperty(key)) {
                key = keys[key].parentObjId
              }
              if (relation['dir'] === 'dst') {
                if (!contents[objKey].hasOwnProperty('next')) {
                  contents[objKey]['next'] = []
                }
                contents[objKey]['next'].push(key)
                this.targets[key] = {type: 'keyresult', id: key, userId: relationUser}
              } else {
                if (!contents[objKey].hasOwnProperty('prev')) {
                  contents[objKey]['prev'] = []
                }
                contents[objKey]['prev'].push(key)
              }
            }
          }
        }
      } else {
        // contents[objKey]['style'] = {left: left, top: top}
      }
      return contents
    },
    generateCytoscapeData: function () {
      // とりあえず,currentで作成し、いずれdata型からfunction型に変更userIdを引数としてcontentsをreturnする
      // let contents = {}
      console.log('generateCytoscapeData:')
      let registerKey = {} // ex:{itemId: 1}
      // const users = this.hierarchyGrant
      const userIds = Object.keys(this.getUsers)
      // targetHierarchy = users[userIds[0]]
      let promises = []
      // let data = {
      //   nodes:{}, edges:{}, nodeStyles:{}
      // }
      if (userIds.length === 0) {
        console.log('users', this.getUsers, userIds)
        return false
      }
      for (let targetUserId of userIds) {
        if (targetUserId === '.key') {
          continue
        }
        const objs = this.getObjectivesByUserId(targetUserId, true)
        let activeObjKeys = Object.keys(objs).filter(objKey => this.isBetweenDate(objs[objKey]))
        // 注釈がないと勘違いしてしまいそうになるのでコメント追加:objのみを対象とし、objが非アクティブならばkeyresultを表示しない(krはactive条件に関係ない)
        if (activeObjKeys.length > 0) {
        }
        for (let objKey of activeObjKeys) {
          // 方針: keyresultの数がわかれば、並列的に処理できるのでそれで行うように変更する
          if (!objKey || !targetUserId) {
            continue
          }
          const obj = objs[objKey]
          if (objKey === '.key' || !obj || !objKey) {
            continue
          }
          if (!obj) {
            continue
          }
          if (registerKey.hasOwnProperty(objKey)) {
            continue
          } else {
            registerKey[objKey] = 1
          }
          promises.push(this.generateOkrData(obj, objKey, targetUserId))
        }
      }
      return Promise.all(promises).then((values) => {
        if (values.length > 0) {
          this.load = true
        }
        let contents = {}
        console.log('values', values)
        for (let value of values) {
          contents = Object.assign(contents, value)
        }
        let nodes = []
        let edges = []
        let info = {} // id参照
        let targetIds = {} // targetIdがtarget/sourceで空の可能性があるので、mapで最終チェックするために
        let errs = []
        console.log('contents', contents)
        for (let value of Object.values(contents)) {
          console.log('value', value)
          let node = {}
          node['data'] = {}
          node['data']['id'] = value.id
          // node['group'] = 'nodes'
          nodes.push(node)
          info[value.id] = {}
          info[value.id]['data'] = value.data // tooltipで表示させるものはこっち
          info[value.id]['data']['username'] = this.userName(value.userId)
          info[value.id]['image'] = this.userImage(value.userId)
          info[value.id]['progress'] = value.progress
          info[value.id]['userId'] = value.userId
          if (value.hasOwnProperty('next')) {
            for (let targetId of value.next) {
              if (!targetIds.hasOwnProperty(targetId)) {
                targetIds[targetId] = []
              }
              targetIds[targetId].push({data: {source: targetId, target: value.id, directed: 'false'}})
            }
          }
        }
        for (let targetId of Object.keys(targetIds)) {
          if (info.hasOwnProperty(targetId)) {
            edges = edges.concat(targetIds[targetId])
          } else {
            errs.push(this.targets[targetId])
          }
        }
        // 同一ノード間以外なら、 source - distの組みで同一なものはない
        // つまりnextとprevを取ってきているなら、edgesにそのまま代入できる -> そのためにもnextかprevどっちか捨てるべきか..
        console.log('contents', nodes, edges, info)
        if (errs.length > 0) {
          console.log('errs', errs)
        }
        // if (values.length > 0) {
        //   this.okrContents = contents
        //   this.doneStarter = true
        // }
        let cytoscapeDatas = {}
        cytoscapeDatas['nodes'] = nodes
        cytoscapeDatas['edges'] = edges
        cytoscapeDatas['infos'] = info
        this.cytoscapeDatas = cytoscapeDatas
        this.view_init(nodes, edges, info)
        console.log('this.cy', this.cy)
      })
    },
    view_init: function (nodes, edges, info) {
      console.log('start')
      // this.generateCytoscapeData()
      console.log('cytoscape', edges)
      let elements = {}
      elements['nodes'] = nodes.reverse()
      elements['edges'] = edges
      console.log('elements', elements)
      let style = []
      style.push(
        {
          selector: 'node',
          css: {
            'height': 80,
            'width': 80,
            'background-fit': 'cover',
            'border-color': '#000',
            'border-width': 15,
            'border-opacity': 4,
            'text-valign': 'center'
          }
        }
      )
      style.push(
        {
          selector: 'edge',
          css: {
            'width': 6,
            'source-arrow-shape': 'triangle',
            'line-color': '#ffaaaa',
            'source-arrow-color': '#ffaaaa',
            'curve-style': 'bezier'
          }
        }
      )
      let check = {}
      let self = this
      for (let [key, value] of Object.entries(info)) {
        let createStyle = {}
        createStyle['selector'] = '#' + key
        createStyle['css'] = {
          'background-image': value['image']
        }
        console.log('progressStyle', progress)
        for (let style of progress) {
          let max = style.max
          if (max >= value['progress']) {
            if (style.color === '#f4e740') {
              createStyle['css']['border-color'] = '#eabf25'
            } else {
              createStyle['css']['border-color'] = style.color
            }
            break
          }
        }
        if (!check.hasOwnProperty(value['images'])) {
          check[value['images']] = 1
        }
        style.push(createStyle)
      }
      console.log('chec', check)
      this.cy = cytoscape(
        {
          container: document.getElementById('cy'),
          boxSelectionEnabled: false,
          autounselectify: true,
          wheelSensitivity: 0.3,
          style: style,
          elements,
          layout: {
            name: 'dagre'
          }
        }
      )
      let conTextRead = function (text) {
        // 138以上なら省略
        let length = 0
        let omit = false
        let omitIndex = 0
        for (let i = 0; i < text.length; i++) {
          let c = text.charCodeAt(i)
          if ((c >= 0x0 && c < 0x81) || (c === 0xf8f0) || (c >= 0xff61 && c < 0xffa0) || (c >= 0xf8f1 && c < 0xf8f4)) {
            length += 1
          } else {
            length += 2
          }
          if (length >= 138) {
            omitIndex = i
            omit = true
            break
          }
        }
        if (omit) {
          let omitText = text.slice(0, omitIndex) + '...'
          return omitText
        } else {
          return text
        }
      }
      let showTooltip = function (node, info) {
        const $t = self.$t
        let ref = node.popperRef()
        let dummyDomEle = document.createElement('div')
        // tooltipようのデータ整形
        let data = []
        // contentText,startdate,duedate,progress,username
        if (info['data'].hasOwnProperty('contentText')) {
          data.push($t('okrDetailType'))
          data.push(conTextRead(info['data']['contentText']))
          data.push('------------------')
        }
        if (info['data'].hasOwnProperty('username')) {
          for (let user of info['data']['username']) {
            data.push($t('profileUserTitle') + ': ' + user)
          }
        }
        if (info['data'].hasOwnProperty('progress')) {
          data.push($t('progressRateLabelTitle') + ': ' + info['data']['progress'])
        }
        let dates = []
        if (info['data'].hasOwnProperty('startDate')) {
          dates.push($t('startDateStr') + ': ' + info['data']['startDate'])
        }
        if (info['data'].hasOwnProperty('dueDate')) {
          dates.push($t('dueDateStr') + ': ' + info['data']['dueDate'])
        }
        data.push(dates.join(' ~ '))
        // for (let [key, value] of Object.entries(info['data'])) {
        //   data.push(key + ': ' + value)
        // }
        let text = data.join('<br>')
        let tip = tippy(dummyDomEle, {
          onCreate: function (instance) {
            instance.popperInstance.reference = ref
          },
          lazy: false,
          trigger: 'manual',
          content: function () {
            let div = document.createElement('div')
            div.innerHTML = text
            return div
          },
          arrow: true,
          placement: 'top',
          hideOnClick: false,
          multiple: true,
          sticky: true,
          interactive: true,
          appendTo: document.body // or append dummyDomEle to document.body
        })
        return tip
      }
      this.cy.on('mouseover', 'node', function (e) {
        let targetId = e.target.json().data['id']
        if (!self.tippes.hasOwnProperty(targetId)) {
          let targetTippy = showTooltip(e.target, info[targetId])
          self.tippes[targetId] = targetTippy
        }
        self.tippes[targetId].show()
      })
      this.cy.on('mouseout', 'node', function (e) {
        let targetId = e.target.json().data['id']
        self.tippes[targetId].hide()
      })
      this.cy.on('mousedown', 'node', function (e) {
        let targetId = e.target.json().data['id']
        self.tippes[targetId].hide() // tippesがshow()発火時にtooltipを生成するので付いてきたりはしないhide
      })
      this.cy.on('tap', 'node', function (e) {
        let targetId = e.target.json().data['id']
        self.$router.push('/okrTree/' + info[targetId]['userId'][0] + '/' + targetId)
      })
    }
  }
  // mergeSort用script
  // ToDo:userid:value となっているobjectをvalue値によって並び替える
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
div.ibox-child span.crown-mark {
  top: 1.0rem;
  left: -1.8rem;
  /* text-shadow: 16px -6px black; */
}
.border-none {
  border: none;
}
.parentPath {
  margin-top: 8px;
}

.grab-bing {
  cursor: -webkit-grab;
  cursor: -moz-grab;
  cursor: -o-grab;
  cursor: grab;
}
.grab-bing:active {
  cursor: -webkit-grabbing;
  cursor: -moz-grabbing;
  cursor: -o-grabbing;
  cursor: grabbing;
}
#box {
  position: relative;
  width: 100%;
  height: 500px;
  overflow: hidden;
  position: absolute;
  border: 1px solid #000;
}
.content {
  width: 50px;
  height: 50px;
  border: 1px solid #000;
  position: relative;
  text-align: center;
}
.content2 {
  width: 50px;
  height: 50px;
  border: 1px solid #000;
  position: relative;
  text-align: center;
}
h4.date-label {
  font-size: 150%;
}
.input-searchType {
  margin: auto 0;
  display: -webkit-inline-box;
  padding-inline-start:1px;
  li:not(:first-child) {
    margin-left: 35px;
  }
  input[type="radio"]~label {
    margin-left: 5px;
  }
}
.search-calendar {
  display: inline-block;
  padding-inline-start:18px;
}
.select-date {
  display: flex;
  margin: auto 0;
}
.report-rel {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.back-btn {
  height: 2.5em;
}
.trisection-wrap {
  height: calc(100% - 5.5em);
}
.trisection-head {
  height: 5em;
}
.trisection {
  height: calc(100% - 7.5em);
  &>div {
    overflow-y: auto;
    // height: calc(72vh);
    height: 100%;
    word-wrap: break-word;
  }
}
.selected {
  .okrItem {
    opacity: .5;
  }
  .target {
    box-shadow: 0 0 .1em .2em #ffcccc;
    .okrItem {
      opacity: 1;
    }
  }
}
.dir-title {
  height: 100%;
  max-height: 6.8rem;
  border: none;
  color: #3e8fe0;
  line-height: 4rem;
}
.trisection-head .flex-box {
  width: 100%;
  align-items: center;
}
.mg-right {
  margin-right: 2rem;
  margin-left: 1rem;
}
.fa-angle-double-left {
  font-size: 1.7em;
  // vertical-align: middle;
}
.bg-info {
  font-size: 12.5px;
  width: 475px;
}
#cy {
  height: 82.5vh;
  width: 100%;
  border: 0.5px solid;
}
</style>



// WEBPACK FOOTER //
// src/components/Okr/Network.vue